export default function FilterToggle({ value, onChange }) {
  const Btn = ({ id, label }) => {
    const on = value === id
    return (
      <button
        onClick={() => onChange(id)}
        className={`rounded-md px-2.5 py-1 text-[12px] ${on ? 'bg-white font-medium text-ink shadow-[0_1px_1.5px_rgba(0,0,0,.05)]' : 'text-muted'}`}
      >
        {label}
      </button>
    )
  }
  return (
    <div className="inline-flex rounded-lg bg-line/60 p-0.5">
      <Btn id="all" label="Tous" />
      <Btn id="essentiels" label="★ Essentiels" />
    </div>
  )
}
